export default __webpack_public_path__ + "static/img15-97dc9263aa49aaf7fd98960b330c4641.png";